export enum ModalType {
  NEW = "NEW",
  EDIT = "EDIT",
  READ = "READ",
}
